import { PopularCategories_CategoryInterface } from "./model";

export const popularCategories_defaultCategories: PopularCategories_CategoryInterface[] = [
  {
    titleText: "Quilt Covers",
    img: "images/plp/category-quilt-covers.png",
    href: "/bed/quilt-covers",
  },
  {
    titleText: "Towels",
    img: "images/plp/category-towels.png",
    href: "/bath/towels",
  },
  {
    titleText: "Home Décor",
    img: "images/plp/category-home-decor.png",
    href: "/home-decor",
  },
  {
    titleText: "Sheet Sets",
    img: "images/plp/category-sheet-sets.png",
    href: "/bed/sheets-pillowcases",
  },
];
